export default __webpack_public_path__ + "static/media/mic.7232ff48.svg";